/*-----------------------------------------------------------------------------/
/ Custom Theme JS — Yoeleo Global Store (yoeleobike.com)
/ Vision Theme
/-----------------------------------------------------------------------------*/

// ============================================================================
// Global Error Tracking
// Catches unhandled JS errors for Microsoft Clarity session tagging.
// This helps identify which sessions experience JS errors so we can
// correlate with conversion drop-offs in Clarity dashboards.
// Added: 2026-03-20 | Priority 1 fix for Clarity JS error reports
// ============================================================================
(function() {
  'use strict';

    var errorCount = 0;
      var maxErrors = 20;

        window.addEventListener('error', function(event) {
            if (errorCount >= maxErrors) return;
                errorCount++;

                    var errorInfo = {
                          message: event.message || 'Unknown error',
                                source: (event.filename || 'unknown').split('/').pop(),
                                      line: event.lineno || 0,
                                            timestamp: new Date().toISOString()
                                                };

                                                    // Log to console for debugging
                                                        if (typeof console !== 'undefined' && console.error) {
                                                              console.error('[Yoeleo Error Tracking]', JSON.stringify(errorInfo));
                                                                  }

                                                                      // Tag the Clarity session with the error info
                                                                          if (typeof window.clarity === 'function') {
                                                                                window.clarity('set', 'js_error', errorInfo.message.substring(0, 100));
                                                                                      window.clarity('set', 'error_source', errorInfo.source);
                                                                                          }
                                                                                            });

                                                                                              // Also catch unhandled promise rejections
                                                                                                window.addEventListener('unhandledrejection', function(event) {
                                                                                                    if (errorCount >= maxErrors) return;
                                                                                                        errorCount++;

                                                                                                            var reason = event.reason ? String(event.reason).substring(0, 100) : 'Unknown rejection';

                                                                                                                if (typeof console !== 'undefined' && console.error) {
                                                                                                                      console.error('[Yoeleo Error Tracking] Unhandled Promise:', reason);
                                                                                                                          }

                                                                                                                              if (typeof window.clarity === 'function') {
                                                                                                                                    window.clarity('set', 'js_error', 'Promise: ' + reason);
                                                                                                                                          window.clarity('set', 'error_type', 'unhandled_rejection');
                                                                                                                                              }
                                                                                                                                                });
                                                                                                                                                })();
